import { CropRatio } from "components/modules/Editors/ImageResizer/EditSettings/CropSettings/CropRatio/CropRatio";
import { Size } from "./Size/Size";
import { useImageCropperCropSettings } from "./useImageCropperCropSettings";
import { Top } from "./Top/Top";
import { Left } from "./Left/Left";
import { DesktopAction } from "../../Action/DesktopAction";
import { Translate } from "components/common/Translate/Translate";

export const ImageCropperCropSettings = () => {
    const {
        handleReset,
        handleWidthChange,
        handleHeightChange,
        handleRatioChange,
        handleTopChange,
        handleLeftChange,
        resetButtonRef,
        customRatioX,
        customRatioY,
        handleCustomRatioXChange,
        handleCustomRatioYChange,
        ratio,
    } = useImageCropperCropSettings();

    return (
        <div className="h-full flex flex-col text-black dark:text-white">
            <div className="h-full max-h-full overflow-y-scroll scroll">
                <div
                    className="capitalize text-2xl font-semibold whitespace-nowrap py-4 px-4"
                    data-testid="crop-settings-title"
                >
                    <Translate keyName="crop-rectangle" />
                </div>

                <div className="flex flex-col justify-between gap-1 h-full">
                    <div className="flex flex-col gap-1 px-4">
                        <Size handleWidthChange={handleWidthChange} handleHeightChange={handleHeightChange} />

                        <div className="mb-2 mt-4 capitalize">
                            <CropRatio
                                customRatioX={customRatioX}
                                customRatioY={customRatioY}
                                handleCropRatioChange={handleRatioChange}
                                handleCustomRatioXChange={handleCustomRatioXChange}
                                handleCustomRatioYChange={handleCustomRatioYChange}
                                ratio={ratio}
                            />
                        </div>

                        <div className="font-semibold text-2xl mt-4 mb-2 capitalize">
                            <Translate keyName="crop-position" />
                        </div>

                        <div className="flex items-center gap-2">
                            <Top handleChange={handleTopChange} />
                            <Left handleChange={handleLeftChange} />
                        </div>

                        <div
                            className={`
                                    cursor-pointer hidden lg:flex items-center justify-center
                                    border-irGray-400 border rounded-lg my-6 text-center py-2
                                    text-xl capitalize hover:bg-irGray-200 dark:bg-darkSurface-300 dark:hover:bg-darkSurface-200 dark:border-darkSurface-100
                                `}
                            onClick={handleReset}
                            ref={resetButtonRef}
                            data-testid="crop-reset-button"
                        >
                            <Translate keyName="reset" />
                        </div>
                    </div>
                </div>
            </div>
            <div className="h-24 w-full">
                <div className="hidden px-1 py-4 lg:flex items-center justify-center bg-white dark:bg-darkSurface-100 border-t border-solid border-t-irGray-200 dark:border-t-darkSurface-600 flex-shrink-0">
                    <DesktopAction />
                </div>
            </div>
        </div>
    );
};
